<template>
  <div class="space-y-4">
    <div class="flex justify-between items-center">
      <h3 class="text-lg font-medium text-gray-900">
        Questions & Answers
      </h3>
      <button
        type="button"
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium
          rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
        @click="addQA">
        <i class="fas fa-plus mr-2" />
        Add Q&A
      </button>
    </div>

    <div
      v-for="(qa, index) in localQAs"
      :key="index"
      class="bg-white shadow rounded-lg p-4">
      <div class="space-y-3">
        <div>
          <label class="block text-sm font-medium text-gray-700">
            Question {{ index + 1 }}
          </label>
          <input
            v-model="qa.question"
            type="text"
            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Enter question..."
            @input="updateQAs">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">
            Answer
          </label>
          <textarea
            v-model="qa.answer"
            rows="2"
            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Enter answer..."
            @input="updateQAs" />
        </div>
        <button
          type="button"
          class="text-red-600 hover:text-red-800 text-sm"
          @click="removeQA(index)">
          <i class="fas fa-trash mr-1" />
          Remove
        </button>
      </div>
    </div>

    <div
      v-if="localQAs.length === 0"
      class="text-center py-8 text-gray-500">
      No Q&As added yet. Click "Add Q&A" to get started.
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

const localQAs = ref([...props.modelValue])

const updateQAs = () => {
  emit('update:modelValue', [...localQAs.value])
}

const addQA = () => {
  localQAs.value.push({ question: '', answer: '' })
  updateQAs()
}

const removeQA = (index) => {
  localQAs.value.splice(index, 1)
  updateQAs()
}

watch(() => props.modelValue, (newValue) => {
  localQAs.value = [...newValue]
}, { deep: true })
</script>
